var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkLinkedinIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CONTACT",
    transform: "translate(-222.000000, -1061.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(222.820000, 1061.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy",
    fill: "#202020"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 2.72727273
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.866,12.320875 L11.866,21 L9.378,21 L9.378,12.320875 L11.866,12.320875 Z M18.1995,12.1025833 C20.7165,12.1025833 21.18,13.8992917 21.18,16.2317083 L21.18,16.2317083 L21.18,20.9994583 L18.6945,21 L18.6943297,16.6523592 C18.6909712,15.6662595 18.62452,14.4761667 17.401,14.4761667 C16.1075,14.4761667 15.9095,15.5703333 15.9095,16.701875 L15.9095,16.701875 L15.9095,20.9994583 L13.4245,20.9994583 L13.4245,12.3203333 L15.811,12.3203333 L15.811,13.503875 L15.846,13.503875 C16.1775,12.8219167 16.9895,12.1025833 18.1995,12.1025833 Z M10.621,8 C11.416,8 12.0615,8.69929167 12.062,9.56108333 C12.062,10.422875 11.4165,11.1367917 10.621,11.1367917 C9.8255,11.1367917 9.18,10.422875 9.18,9.56108333 C9.18,8.69929167 9.8255,8 10.621,8 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLinkedinIc);
export default __webpack_public_path__ + "static/media/dark_linkedin_ic.3bcff94750a67fa5d837c5044b5088fd.svg";
export { ForwardRef as ReactComponent };